import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function CategoryView({ category, categoryOption, onCategoryTrigger }) {
  const { initialValues, categorys } = categoryOption;

  return (
    <div className="c-bbs__tab">
      <ul className="tab__list">
        {categorys &&
          categorys?.map(c => {
            return (
              <li
                className={`tab__list--item ${
                  c.key === (category || initialValues.category) && 'active'
                }`}
              >
                <Link
                  onClick={event => {
                    onCategoryTrigger && onCategoryTrigger(event, c.key);
                  }}
                >
                  {c.name}
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
}

CategoryView.propTypes = {
  category: PropTypes.string.isRequired,
  categoryOption: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  ).isRequired,
  onCategoryTrigger: PropTypes.func.isRequired,
};

export default CategoryView;
